/* eslint-disable no-nested-ternary */
import styled, { keyframes, css } from 'styled-components';
import { media } from '@navent-re/global-styled';

const animationStyles = animation => {
  const openBottomKeyframe = keyframes`
		0% { bottom: ${animation.position} }
		100% { bottom: 0% }
	`;

  const openTopKeyframe = keyframes`
		0% { top: ${animation.position} }
		100% { top: 0% }
	`;

  const fadeIn = keyframes`
		0% { transform: scale(.25);	opacity: 0; }
		100% { transform: scale(1);	opacity: 1; }
	`;

  const animations = {
    fadeIn: css`
      animation: ${fadeIn} 0.2s 1;
    `,
    openTop: css`
      animation: ${openTopKeyframe} 0.2s 1;
    `,
    openBottom: css`
      animation: ${openBottomKeyframe} 0.2s 1;
    `
  };

  return animations[animation.type];
};

const handleOpenFrom = openFrom => {
  const open = {
    top: 'align-items: flex-start;',
    bottom: 'align-items: flex-end',
    default: 'align-items: center;'
  };
  return open[openFrom] || open.default;
};

export const ModalBackground = styled.div`
  position: fixed;
  background-color: ${props => props.noBackgroundOpacity || 'rgba(0, 0, 0, 0.6)'};
  top: ${({ top }) => top || 0};
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  box-shadow: 0 2px 4px 0 rgba(50, 50, 93, 0.1);
  display: flex;
  justify-content: ${props =>
    props.xAlign === 'left' ? 'flex-start' : props.xAlign === 'right' ? 'flex-end' : 'center'};
  padding: ${props => props.padding || '0px'};
  width: ${({ maxContent }) => (maxContent ? 'max-content' : 'initial')};
  height: ${({ maxContent }) => (maxContent ? 'max-content' : 'initial')};
  ${({ openFrom }) => handleOpenFrom(openFrom)};
`;

export const ModalContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.width || '400px'};
  height: ${props => props.height || 'auto'};
  overflow: ${props => props.overflow || 'hidden'};
  ${({ animation }) => animationStyles(animation)};

  @media ${media.tablet} {
    max-height: 99vh;
    align-items: flex-start;
  }
`;

export const ModalButtonClose = styled.button`
  z-index: 99;
  position: absolute;
  right: 16px;
  top: 16px;
  background-color: transparent;
  font-size: 14px;

  & > svg,
  img {
    width: 20px;
    height: 20px;
  }

  @media ${media.mobile} {
    right: 12px;
    top: 12px;
  }
`;
